import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found-image',
  templateUrl: './page-not-found-left-panel.component.html',
  styleUrls: ['./page-not-found-left-panel.component.css']
})
export class PageNotFoundLeftPanelComponent {

}
